import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/theme.css'
import { initTheme } from './utils/theme'

initTheme()
createApp(App).use(router).mount('#app')
